<template>
  <EOEmpressCheckout :combos="combos" />
</template>

<script>
import EOEmpressCheckout from "@/components/checkout/eoempress/EOEmpressCheckout.vue";

export default {
  name: "EOEmpress",
  components: {
    EOEmpressCheckout,
  },
  props: {
    combos: {
      type: Array,
      default: () => [57],
    },
  },
};
</script>
